// Configuration des variables d'environnement
export const config = {
  // Google Analytics
  GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-YQFRYB584C',

  // URL du site
  SITE_URL: process.env.REACT_APP_SITE_URL || 'https://godleadershop.ci',

  // Configuration PWA
  PWA_NAME: process.env.REACT_APP_PWA_NAME || 'GodLeadersShop',
  PWA_DESCRIPTION: process.env.REACT_APP_PWA_DESCRIPTION || 'Boutique en ligne de LeadershipForGod',

  // Environnement
  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
};

// Vérification des variables d'environnement requises
export const validateEnv = () => {
  const required = ['REACT_APP_GA_MEASUREMENT_ID'];
  const missing = required.filter(key => !process.env[key]);

  if (missing.length > 0) {
    console.warn('Variables d\'environnement manquantes:', missing);
  }

  return missing.length === 0;
};

export default config;
